// core
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import moment from 'moment';

// pipes
import { DisplayDatePipe } from '@open-portal-app/core/pipes/display-date.pipe';


// services
import {
  PdsService,
  ProductService,
  PartnerBrandService
} from '@campfire-nx/api';

@Injectable({
  providedIn: 'root'
})
export class DocumentsResolver implements Resolve<boolean> {
  constructor(
    private pdsService: PdsService,
    private productService: ProductService,
    public partnerBrandService: PartnerBrandService,
    private displayDatePipe: DisplayDatePipe
  ) {}

  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<any> | Promise<any> | any {
    let productDocuments: Array<any> = [];
    const documentsDetailsArray: any = {};
    const partner = route.queryParams.partner || 'open';
    const productSlug = route.queryParams.product || null;
    this.partnerBrandService.setPartner(partner);

    return this.pdsService.history(productSlug)
      .then((response: any) => {
        productDocuments = response;
        // get the documents for each of the products
        productSlug.split(',').forEach((item:any, index:number) => {
          this.productService.detail(item).then((productServiceResponse: any) => {
            // set the first product into storage so country details are available
            if (index === 0) {
              this.partnerBrandService.setAttribute('product', productServiceResponse, 'partner');
            }
            documentsDetailsArray[item] = this.mapProductDocuments(productDocuments[item]);
            documentsDetailsArray[item].type = productServiceResponse.class;
            documentsDetailsArray[item].label = productServiceResponse.label;
          });
        });
        
        return documentsDetailsArray;
      });
  }

  mapProductDocuments(productDocuments: any): any {
    let now = moment();
    let latestPdsDocuments: Array<any> = [];
    let latestResourceDocuments: Array<any> = [];
    let uniqueDocumentTypesArray = [
      ...new Set(productDocuments.map((element: { type: String }) => element.type))
    ];

    for (const documentType of uniqueDocumentTypesArray) {
      const matchedDocumentType: Array<any> = productDocuments.filter(
        (file: any) => file.type === documentType
      );      
      const documents = matchedDocumentType.sort(
        (
          a: { end_date: moment.MomentInput },
          b: { end_date: moment.MomentInput }
        ) => (moment(a.end_date) < moment(b.end_date) ? 1 : -1)
      );
      const latestDocuments = documents.filter((document: any) => {
        return moment(document.end_date) > now || document.end_date === null;
      });
      
      if (documentType === 'pds') {
        latestPdsDocuments = latestDocuments;
      } else {
        latestResourceDocuments = latestResourceDocuments.concat(latestDocuments);
      }
    }

    return {
      pdsDocuments: latestPdsDocuments,
      pdsLatestDocumentDate: this.displayDatePipe.transform(latestPdsDocuments.length > 0 ? latestPdsDocuments[0].start_date : ''),
      resourceDocuments: latestResourceDocuments
    };
  }
}
